exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-wrapper p[data-v-40d7740a] {\n  margin: 0;\n}\n.select-wrapper label[data-v-40d7740a] {\n  padding-left: 10px;\n}\n.select-wrapper input[data-v-40d7740a] {\n  margin-left: 20px;\n}", ""]);

// exports
